global.getUrlParams = function () {
    let query = location.search.substr(1);
    let result = {};

    if (!query) {
        return result;
    }

    query.split("&").forEach(function (part) {
        let item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
    });

    return result;
};

global.setUrlParams = function (params) {
    let out = [];

    for (let key in params) {
        if (params.hasOwnProperty(key)) {
            out.push(key + '=' + encodeURIComponent(params[key]));
        }
    }

    window.location.search = out.join('&');
};